import { render, staticRenderFns } from "./DogOrder.vue?vue&type=template&id=06e46149&scoped=true"
import script from "./DogOrder.vue?vue&type=script&lang=js"
export * from "./DogOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e46149",
  null
  
)

export default component.exports